module.exports = __webpack_public_path__ + "static/fonts/DINProMedium.92714413.woff2";